/* Decode the HTML entities WordPress commonly emits in titles and short-titles.
   SSR-safe — pure string transform, no DOM dependency. Covers the named entities
   editors hit most often plus numeric forms (&#NN; and &#xHH;). Anything else
   (rare named entities like &hearts;) passes through unchanged. */
const namedEntities: Record<string, string> = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&apos;': '\'',
    '&#039;': '\'',
    '&nbsp;': ' ',
    '&hellip;': '…',
    '&ndash;': '–',
    '&mdash;': '—',
    '&lsquo;': '‘',
    '&rsquo;': '’',
    '&ldquo;': '“',
    '&rdquo;': '”',
};

export const decodeHtmlEntities = (text?: string) => {
    if (!text || typeof text !== 'string') {
        return '';
    }

    let out = text;
    for (const [entity, char] of Object.entries(namedEntities)) {
        out = out.split(entity).join(char);
    }
    out = out.replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)));
    out = out.replace(/&#x([0-9a-fA-F]+);/g, (_, code) => String.fromCharCode(parseInt(code, 16)));
    return out;
};

export default decodeHtmlEntities;
